import { ModuleFE_Value, ModuleFE_Variable } from '../_entity.js';
import { DBDef_ContextRule, DBDef_Expression, DBDef_Resource, DBDef_Tag, DBDef_Value, DBDef_Variable, DBDef_VariableRelation, } from '@app/hcs-shared';
const conflictResolutionItem_Tag = {
    dbKey: DBDef_Tag.dbKey,
    collectionRenderer: dbKey => 'Tags',
    renderer: tag => tag.label,
    filterMapper: tag => [tag.label],
};
const conflictResolutionItem_Variable = {
    dbKey: DBDef_Variable.dbKey,
    renderer: variable => variable.name,
    collectionRenderer: dbKey => 'Variables',
    filterMapper: variable => [variable._nameInLowercase],
};
const conflictResolutionItem_VariableRelation = {
    dbKey: DBDef_VariableRelation.dbKey,
    collectionRenderer: dbKey => 'Variable Relations',
    renderer: relation => {
        const leftVar = ModuleFE_Variable.cache.unique(relation.leftSide[0]?.variableId);
        const rightVar = ModuleFE_Variable.cache.unique(relation.rightSide[0]?.variableId);
        if (!leftVar)
            return;
        return `${leftVar.name} "${relation.relation}" ${rightVar?.name ?? ''}`;
    },
    filterMapper: relation => {
        const leftVar = ModuleFE_Variable.cache.unique(relation.leftSide[0]?.variableId);
        return leftVar ? [leftVar.name] : [];
    },
};
const conflictResolutionItem_Expression = {
    dbKey: DBDef_Expression.dbKey,
    renderer: expression => expression.label,
    collectionRenderer: dbKey => 'Expressions',
    filterMapper: expression => [expression.label],
};
const conflictResolutionItem_Resource = {
    dbKey: DBDef_Resource.dbKey,
    collectionRenderer: dbKey => 'Resources',
    renderer: resource => resource.label,
    filterMapper: resource => [resource.label],
};
const conflictResolutionItem_ContextRule = {
    dbKey: DBDef_ContextRule.dbKey,
    collectionRenderer: () => 'Context Rules',
    renderer: cr => cr.label,
    filterMapper: cr => [cr.label],
};
const conflictResolutionItem_Value = {
    dbKey: DBDef_Value.dbKey,
    collectionRenderer: () => 'Values',
    renderer: value => ModuleFE_Value.getValueLabel(value),
    filterMapper: value => {
        const label = ModuleFE_Value.getValueLabel(value);
        return label ? [label] : [];
    },
};
export const ConflictResolutionItemGroup_HCS = [
    conflictResolutionItem_Tag,
    conflictResolutionItem_Variable,
    conflictResolutionItem_Expression,
    conflictResolutionItem_VariableRelation,
    conflictResolutionItem_Resource,
    conflictResolutionItem_ContextRule,
    conflictResolutionItem_Value,
];
//# sourceMappingURL=conflict-resolution-items.js.map